// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"0304594e742df81f","9226":"35e9b63c902bff35"}[chunkId] + ".css";
};